import type { NodeViewRendererProps } from '@tiptap/core';

/** Persist intrinsic dimensions for either image node without disturbing selection or undo. */
export function ensureImageDimensions(props: NodeViewRendererProps, image: HTMLImageElement) {
    const { editor, getPos } = props;
    if (editor.isDestroyed || !editor.isEditable) return;
    const { naturalWidth, naturalHeight } = image;
    if (!(naturalWidth > 0 && naturalHeight > 0)) return;
    const pos = getPos();
    if (typeof pos !== 'number') return;
    editor.commands.command(({ tr }) => {
        const node = tr.doc.nodeAt(pos);
        if (!node || node.type !== props.node.type || node.attrs.src !== image.getAttribute('src')) return false;
        const width = Number(node.attrs.width);
        const height = Number(node.attrs.height);
        const hasWidth = Number.isInteger(width) && width > 0;
        const hasHeight = Number.isInteger(height) && height > 0;
        if (hasWidth && hasHeight) return false;
        tr.setNodeMarkup(pos, undefined, {
            ...node.attrs,
            width: hasWidth ? width : hasHeight ? Math.max(1, Math.round(naturalWidth * height / naturalHeight)) : naturalWidth,
            height: hasHeight ? height : hasWidth ? Math.max(1, Math.round(naturalHeight * width / naturalWidth)) : naturalHeight,
        }).setMeta('addToHistory', false);
        return true;
    });
}
